/**
 * 用户权限管理
 */
import { get, post } from '@/utils/request'

const TYPE = 'JSON'

// 获取用户分页列表
export const getUserList = params => post('/user/listUser', params)

// 用户管理中心
export const getUserHome = params => get('/user/getUserManageHome', params)

// 获取用户详情
export const getUserDetailById = params => get(`/user/detail/${params.userId}`)

// 添加用户
export const addUser = params => post('/user/addUser', params, { TYPE })

// 更新用户
export const updateUser = params => post('/user/updateUser', params, { TYPE })

// 标记删除用户
export const deleteUser = params => post('/user/removeUser', params)

// 下载导入模板
export const downloadUserTpl = params => get('/user/downloadUserTemplate', params)

// 导入用户
export const importUserData = params => post('/user/importUserData', params, { TYPE: 'FILE' })

// 添加角色以及菜单授权
export const addRoleMenu = params => post('/role/addRoleMenu', params, { TYPE })

// 获取商户角色授权菜单树
// ${params.roleId ? '/'+ params.roleId : ''}
export const getRoleMenuList = params => get(`/role/getRoleMenuList`, params)

// 获取当前登录用户权限菜单
export const getMenuList = params => get(`/menu/getMerchantMenuList`, params)

// 角色列表
export const listRole = params => post('/role/listRole', params)

// 删除角色
export const removeRole = params => post('/role/removeRole', params)

// 编辑角色及菜单授权
export const updateRoleMenu = params => post('/role/updateRoleMenu', params, { TYPE })

// 获取当前商家类型
export const getShopType = () => get('/shop/apply/getShopType')

// // 获取所有菜单資源
// export function getMenuTree() {
//     return get('/api/operate-resources/list')
// }

// // 获取角色对应資源
// export function getRoleInfoById(id) {
//     return get(`/api/operate-role/${id}`)
// }
